import { PALETTE } from "../../common/styles/palette"

export const styles = (theme: any) => {
    return {
        listItemContainerFields: {
            alignItems: 'center',
            padding: '5px',
        },
        listItemContainer: {
            alignItems: 'center',
            padding: '5px',
        },
        listItemContainerSelected: {
            alignItems: 'center',
            padding: '5px',
            backgroundColor: '#fcdbbb'
        },
        calendarButton: {
            marginTop: 0,
            padding: "2px"
        },
        calendarButtonContainer: {
            display: "flex",
            justifyContent: "center",
        },
        listItemIcon: {
            marginLeft: '5px',
            display: 'flex',
            justifyContent: 'center',
            marginRight: '5px',
            marginTop: '17px',
            marginBottom: '17px',
            width: '40px',
            height: '40px',
            border: '1px solid black',
            backgroundColor: PALETTE.UI.Images.BackgroundColor
        },
        listItemButtonsContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        rightAlignedButtons: {
            justifyContent: 'flex-end',
            display: 'flex'
        },
        newActivityDatesContainer: {
            display: 'flex',
            flexDirection: 'row' as 'row'
        },
        newActivityDate: {
            paddingLeft: 10,
            paddingRight: 10,
            display: 'flex',
            alignItems: 'center',
        },
        dayElement: {
            marginTop: 0,
            marginLeft: 10,
            marginRight: 10
        },
        newActivityCheckBoxLabel: {
            marginTop: '20px'
        },
        newActivityCheckBoxPrenotabile: {
            paddingLeft: '40px'
        },
        newActivityPopupContainer: {
            minHeight: 400,
            minWidth: 400
        },
        alterDatesPopupContainer: {
            minHeight: 400,
            minWidth: 400,
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'column' as 'column',
            padding: 40
        },
        approvePopupContainer: {
            minWidth: 400,
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'column' as 'column',
            padding: 40
        },
        searchButtonContainer: {
            display: 'flex',
            alignItems: 'center',
            [theme.breakpoints.only('xs')]: {
                justifyContent: 'center',
            }
        },
        searchButtons: {
            width: '100%',
            paddingLeft: '10px',
            display: 'flex'
        },
        searchButton: {
            marginLeft: '10px',
            marginRight: '10px',
        },
        buttonsContainer: {
            display: 'flex',
            justifyContent: 'space-evenly',
            padding: 10
        },
        trainersContainer: {
            display: 'flex',
            alignItems: 'center'
        },
        trainersButton: {
            display: 'flex',
            justifyContent: 'center'
        },
        addTrainerButtonContainer:{
            display: "flex",
            justifyContent: "center",
        },
        btnReservations: {
            marginTop: 0
        },
        reservationDialog: {
            minWidth: 700,
            minHeight: 500
        },
        reservationDialogHeader: {
            alignItems: 'center',
            // padding: '10px',
        },
        tableRow: {
            padding: "5px 0px",
            "&:hover": {
                backgroundColor: "#ececec",
            }
        },
        tableHeader: {
            backgroundColor: PALETTE.UI.TablesHeader.BackgroundColor,
            display: 'flex',
            alignItems: 'center',
            padding: "0px",
            borderRadius: "5px 5px 0 0",
        },
        table: {
            display: 'flex',
            alignItems: 'center',
        },
        tableHeaderCell: {
            display: 'flex',
            padding: "2px 5px",
            alignItems: 'center',
            "&.first": {
                borderRadius: "5px 0 0 0",
            },
            "&.last": {
                borderRadius: "0 5px 0 0",
            },
        },
        detailHeaderText: {
            paddingLeft: '0px'
        },
        addReservationDialog: {
            minHeight: 500,
            minWidth: 700
        },
        reservationSlotDetailDialogContent: {
            display: 'flex',
            flexDirection: 'column'
        },
        reservationSlotDetailDialogButtons: {
            display: 'flex',
            justifyContent: 'center'
        },
        reservationSlotDetailDialogButton: {
            margin: 5
        }
    }
}